import './vendors';
import 'common/util/jq-plugins';
import './utils';
import './intersection';
import {jsTabs} from 'assembly/parts/js-blocks/js-tabs/js-tabs';
import slider from 'assembly/parts/js-blocks/js-slider/js-slider';
import jsToggler from 'assembly/parts/js-blocks/js-toggler/js-toggler';
import tooltip from 'assembly/parts/js-blocks/js-tooltip/js-tooltip';
import rangeSlider from 'assembly/parts/js-blocks/js-range-slider/js-range-slider';
import scrollbar from 'assembly/parts/js-blocks/js-scrollbar/js-scrollbar';
import shareBtn from 'assembly/parts/js-blocks/js-share-btn/js-share-btn';
import scrollToAnchor from 'assembly/parts/js-blocks/js-scroll2anchor/js-scroll2anchor';
import searchpro from 'assembly/parts/blocks/searchpro/searchpro';
import header from 'assembly/parts/blocks/header/header';
import menu from 'assembly/parts/blocks/menu/menu';
import modal from 'assembly/parts/layouts/modal/modal';
import waField from 'assembly/parts/blocks/wa-field/wa-field';
import form from 'assembly/parts/blocks/form/form';
import formReg from 'assembly/parts/blocks/form-reg/form-reg';
import countdown from 'assembly/parts/js-blocks/js-countdown/js-countdown';
// import searchMobile from 'assembly/parts/blocks/search-mobile/search-mobile';
import oc from 'assembly/parts/blocks/oc/oc';
import cityPlugin from 'assembly/parts/blocks/city-plugin/city-plugin';
import formOrderstatus from 'assembly/parts/blocks/form-orderstatus/form-orderstatus';
import formgroup from 'assembly/parts/blocks/formgroup/formgroup';
import formLogin from 'assembly/parts/blocks/form-login/form-login';
import filters from 'assembly/parts/blocks/filters/filters';
import filter from 'assembly/parts/blocks/filter/filter';
import filtersList from 'assembly/parts/blocks/filters-list/filters-list';
import sorting from 'assembly/parts/blocks/sorting-options/sorting-options';
import pagination from 'assembly/parts/blocks/pagination/pagination';
import products from 'assembly/parts/blocks/products/products';
import favoriteButton from 'assembly/parts/js-blocks/js-favorite-button/js-favorite-button';
import compareButton from 'assembly/parts/js-blocks/js-compare-button/js-compare-button';
import recentButton from 'assembly/parts/js-blocks/js-recent-button/js-recent-button';
import favorites from 'assembly/parts/blocks/favorites/favorites';
import compare from 'assembly/parts/blocks/compare/compare';
import add2cart from 'assembly/parts/js-blocks/js-add2cart/js-add2cart';
import infoPanel from 'assembly/parts/blocks/info-panel/info-panel';
import setPanel from 'assembly/parts/blocks/set-panel/set-panel';
import basketInfo from 'assembly/parts/blocks/basket-info/basket-info';
import modalCatalog from 'assembly/parts/blocks/modal-catalog/modal-catalog';
import selectDecorator from 'assembly/parts/js-blocks/js-select-decorator/js-select-decorator';
import dropdown from 'assembly/parts/blocks/dropdown/dropdown';
import shopPage from 'assembly/parts/layouts/shop-page/shop-page';
import breadcrumbs from 'assembly/parts/blocks/breadcrumbs/breadcrumbs';
import productImages from 'assembly/parts/blocks/product-images/product-images';
import ytVideo from 'assembly/parts/blocks/yt-video/yt-video';
import productReviews from 'assembly/parts/blocks/product-reviews/product-reviews';
import productReviewsImages from 'assembly/parts/blocks/product-reviews-images/product-reviews-images';
import productReview from 'assembly/parts/blocks/product-review/product-review';
import ProductReviewForm from 'assembly/parts/blocks/product-review-form/product-review-form';
import ShopReviewForm from 'assembly/parts/blocks/shop-review-form/shop-review-form';
import cmodal from 'assembly/parts/layouts/modal/cmodal';
import ratingSelect from 'assembly/parts/blocks/rating-select/rating-select';
import photoUpload from 'assembly/parts/blocks/photo-upload/photo-upload';
import card from 'assembly/parts/blocks/card/card';
import yaShare2 from 'assembly/parts/blocks/ya-share2/ya-share2';
import toCart from 'assembly/parts/blocks/to-cart/to-cart';
import buy1clickForm from 'assembly/parts/blocks/buy1click-form/buy1click-form';
import pluginArrived from 'assembly/parts/blocks/plugin_arrived/plugin-arrived';
import bestprice from 'assembly/parts/blocks/bestprice/bestprice';
import formgroupDecorator from 'assembly/parts/js-blocks/js-formgroup-decorator/js-formgroup-decorator';
import my from 'assembly/parts/layouts/my/my';
import page from 'assembly/parts/layouts/page/page';
import cartItemModal from 'assembly/parts/blocks/cart-item-modal/cart-item-modal';
import quantity from 'assembly/parts/blocks/quantity/quantity';
import cartItem from 'assembly/parts/blocks/cart-item/cart-item';
import map from 'assembly/parts/blocks/map/map';
import pointsDp from 'assembly/parts/blocks/points-dp/points-dp';
import pointsDpBalloon from 'assembly/parts/blocks/points-dp-balloon/points-dp-balloon';
import jsOverlayTrigger from 'assembly/parts/js-blocks/js-overlay-trigger/js-overlay-trigger';
import courierDp from 'assembly/parts/blocks/courier-dp/courier-dp';
import courierDpBalloon from 'assembly/parts/blocks/courier-dp-balloon/_courier-dp-balloon';
import cartSummary from 'assembly/parts/blocks/cart-summary/cart-summary';
import rowValue from 'assembly/parts/blocks/row-value/row-value';
import jsContentDecorator from 'assembly/parts/js-blocks/js-content-decorator/js-content-decorator';
import product from 'assembly/parts/blocks/product/product';
import linksBox from 'assembly/parts/blocks/links-box/links-box';
import buy1stepConfirmationForm
	from 'assembly/parts/blocks/buy1step-confirmation-form/buy1step-confirmation-form';
import yaShare2Link from 'assembly/parts/blocks/ya-share2-link/ya-share2-link';
import productReviewsOverview from 'assembly/parts/blocks/product-reviews-overview/product-reviews-overview';
import subscribeForm from 'assembly/parts/blocks/subscribe-form/subscribe-form';
import info from 'assembly/parts/blocks/info/info';
import myOrderPinForm from 'assembly/parts/blocks/my-order-pin-form/my-order-pin-form';
import cartCoupon from 'assembly/parts/blocks/cart-coupon/cart-coupon';
import toggler from 'assembly/parts/blocks/toggler/toggler';
import brandReviewForm from 'assembly/parts/blocks/brand-review-form/brand-review-form';
import formSetPassword from 'assembly/parts/blocks/form-set-password/form-set-password';
import formForgotPassword from 'assembly/parts/blocks/form-forgot-password/form-forgot-password';
import 'assembly/parts/blocks/range/range';
import jsScrollpointAniamtion from 'assembly/parts/js-blocks/js-scrollpoint-animation/js-scrollpoint-animation';
import OptForm from 'assembly/parts/blocks/opt-form/opt-form';
import jsOrderStatus from 'assembly/parts/js-blocks/js-orderstatus/js-orderstatus'
import calculator from 'assembly/parts/blocks/calculator/calculator';
import FixedBar from 'assembly/parts/blocks/fixed-bar/fixed-bar'
import footer from 'assembly/parts/blocks/footer/footer'
import PluginMyOffer from 'assembly/parts/blocks/plugin-my-offer/plugin-my-offer'
import CartItemDeleteModal from 'assembly/parts/blocks/cart-item-delete-modal/cart-item-delete-modal'
import Productgroups from 'assembly/parts/blocks/plugin-productgroups/productgroups'
import CreditInfo from 'assembly/parts/blocks/credit-info/credit-info'
import ProductsCalc from 'assembly/parts/blocks/products-calc/products-calc'
import PaymentMethodsPopup from 'assembly/parts/blocks/payment-methods-popup/payment-methods-popup'
import JsSliderTags from 'assembly/parts/js-blocks/js-slider-tags/js-slider-tags';
import '@tcb-web/create-credit/dist/create-button';
import JsCatalogBannerSlider from 'assembly/parts/js-blocks/js-catalog-banner-slider/js-catalog-banner-slider';
import DecorationsCoupon from 'assembly/parts/blocks/decorations-coupon/decorations-coupon';
import OurProjects from 'assembly/parts/blocks/our-projects/our-projects';
import OurClients from 'assembly/parts/blocks/our-clients/our-clients';
import crmForm from './crm-form';
import dpDialog from 'assembly/parts/blocks/dp-dialog/_dp-dialog';
import addGifts from 'assembly/parts/blocks/plugin-addgifts/plugin.addgifts';
import ReviewFormBig from 'assembly/parts/blocks/review-form-big/review-form-big';
import './video-iframe';
import './thumbs-slider';
import './tabs-slider';
import './product-thumbs.scss';
import './product-thumb';
import './icon.scss';
import './product-badge.scss';
import './product-rating.scss';
import './product-video-icon';
import './product-group-elements';
import './round-button.scss';
import './product-row';
import './product-rows.scss';
import './products-item-gallery'
import './products-item-gallery.scss'
import './label-text.scss';
import './transparent-button.scss';
import './manufacturer-card.scss';
import './review-thumbs-slider';
import './product-thumbs-slider.scss';
import 'common/tabs';
import './grouped-product-thumbs';
import './text-lines.scss';
import './info-banner.scss'
import './hide.scss'
import 'common/img-slider.scss'
import './lazy-image.scss'

import 'assembly/index.scss';
import ModalUtil from 'common/util/ModalUtil';

Cookies.defaults = {expires: 7};

$(document).on('click', 'a[href="#"]', function (e) {
	e.preventDefault();
});
$(document).on('touchstart', 'a', function () {
});

if (location.href.indexOf('/cart/') < 0) {
	Cookies.remove('cart_submitted');

	if (location.href.indexOf('/checkout/') < 0) {
		Cookies.remove('isCredit');
	}
}

header();
jsTabs();
slider();
jsToggler();
selectDecorator();
dropdown();
formgroupDecorator();
searchpro();
scrollbar();
menu();
modal();
waField();
form();
formReg();
countdown();
// searchMobile();
oc();
cityPlugin();
formOrderstatus();
formgroup();
tooltip();
formLogin();
filters();
filter();
rangeSlider();
filtersList();
sorting();
pagination();
favoriteButton();
compareButton();
recentButton();
favorites();
compare();
add2cart();
setPanel();
basketInfo();
products();
modalCatalog();
my();
page();
map();
pointsDp();
pointsDpBalloon();
courierDp();
courierDpBalloon();
new jsOverlayTrigger();
linksBox();
yaShare2Link();
shopPage();
breadcrumbs();
product();
productImages();
ytVideo();
productReviews();
productReviewsImages();
productReview();
productReviewsOverview();
ProductReviewForm();
ShopReviewForm();
cmodal();
ratingSelect();
photoUpload();
card();
yaShare2();
shareBtn();
toCart();
buy1clickForm();
pluginArrived();
bestprice();
cartItemModal();
quantity();
cartItem();
scrollToAnchor();
cartSummary();
rowValue();
jsContentDecorator();
buy1stepConfirmationForm();
subscribeForm();
info();
myOrderPinForm();
cartCoupon();
toggler();
brandReviewForm();
formSetPassword();
formForgotPassword();
jsScrollpointAniamtion();
OptForm();
jsOrderStatus();
calculator();
FixedBar();
footer();
PluginMyOffer();
CartItemDeleteModal();
Productgroups();
CreditInfo();
ProductsCalc();
JsSliderTags();
PaymentMethodsPopup();
JsCatalogBannerSlider();
DecorationsCoupon();
OurProjects();
OurClients();
crmForm();
dpDialog();
addGifts();
ReviewFormBig();
window.infoPanel = infoPanel();

$('.open-login-btn').on('click', function () {
	let $form = $($('#index-modal-login-template').prop('content').cloneNode(true));
	ModalUtil.openContent($form, function () {
		Update($form.parent());
	});
});

$('.open-catalog-modal-btn').on('click', function() {
	let $modalCatalog = $($('#index-modal-catalog-template').prop('content').cloneNode(true));

	ModalUtil.openContent($modalCatalog, function () {
		Update($modalCatalog.parent());
	});
});

$(document).on('click', '.modal-content-button', function () {
		const $btn = $(this)
		const $content = $($btn.data('content'));


		if ($content.length) {
				const $popup = $(window.elkitorg_config.modal_template);
				const title = $btn.data('title');
				const classes = $btn.data('classes');

				$popup.find('.modal__inner').append($content);

				if (classes !== undefined) {
					$popup.addClass(classes);
				}

				if (title !== undefined) {
						$popup.find('.modal__title').text(title);
				}

				ModalUtil.openContent($popup);
		}
})